export class TripFilter {
    clientId?: number;
    shippingLineId?: number;
    createdBy?: number;

    isPaid?: boolean;
    isDone?: boolean;
    containerNumber?: string;
    billOfLading?: string;
    tripId?: number;

    hasUnshippedContainers?: boolean;
    hasEnrouteImportTrip?: boolean;

    createdDateFrom?: Date | string;
}


// WEBPACK FOOTER //
// ./src/app/models/trips/tripFilter.ts